import { z } from "zod";

/**
 * First name field
 */
export const firstNameField = z
  .string()
  .min(1, "First Name is required")
  .max(150, "First name must be 150 characters or less");

/**
 * Last name field
 */
export const lastNameField = z
  .string()
  .min(1, "Last Name is required")
  .max(150, "Last name must be 150 characters or less");

/**
 * Optional first name field (no validation when empty)
 */
export const optionalFirstNameField = z
  .string()
  .max(150, "First name must be 150 characters or less");

/**
 * Optional last name field (no validation when empty)
 */
export const optionalLastNameField = z
  .string()
  .max(150, "Last name must be 150 characters or less");
